import { gridSizeMdLg12, gridSizeMdLg6 } from "@/shared";
import {
  CustomTextAreaNoForm,
  CustomTextField,
  TabTextLabel,
} from "@/shared/components/ui";
import ImagesWithZoom from "@/shared/components/ui/Images/ImagesWithZoom";
import { Grid } from "@mui/material";

export type OTDetalleClienteInstallTecnicoFormTabProps = {
  //form: UseFormReturn<SaveFormDataInstallTecAsig, any>;
  form: any;
  errors: any;
  shrink: boolean;
};

const OTDetalleClienteInstallTecnicoFormTab: React.FC<
  OTDetalleClienteInstallTecnicoFormTabProps
> = ({ errors, form, shrink }) => {
  return (
    <>
      <TabTextLabel text="Cliente" pb={2} pt={2} />

      <CustomTextField
        name="tipo_identificacion"
        label="Tipo de Identificación"
        control={form.control}
        defaultValue={form.getValues().tipo_identificacion || ""}
        error={errors.tipo_identificacion}
        helperText={errors.tipo_identificacion?.message?.toString() ?? ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />

      <CustomTextField
        name="identificacion"
        label="No. Identificación"
        control={form.control}
        defaultValue={form.getValues().identificacion || ""}
        error={errors.identificacion}
        helperText={errors.identificacion?.message?.toString() ?? ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />

      <CustomTextField
        name="razon_social"
        label="Nombre"
        control={form.control}
        defaultValue={form.getValues().razon_social || ""}
        error={errors.razon_social}
        helperText={errors.razon_social?.message?.toString() ?? ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextField
        name="tag"
        label="Etiqueta"
        control={form.control}
        defaultValue={
          form.getValues().tag || "Etiqueta no registrada"
        }
        error={errors.tag}
        helperText={errors.tag?.message?.toString() ?? ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />

      <CustomTextAreaNoForm
        label="Observación 1 Vendedor"
        value={
          (form.getValues()?.observaciones?.observacion_1 as string) ||
          "***NO SE TIENE OBSERVACIÓN DE VENDEDOR 1***"
        }
        disabled
      />
      <CustomTextAreaNoForm
        label="Observación 2 Vendedor"
        value={
          (form.getValues()?.observaciones?.observacion_2 as string) ||
          "***NO SE TIENE OBSERVACIÓN DE VENDEDOR 2***"
        }
        disabled
      />
      <CustomTextAreaNoForm
        label="Observación Llamada"
        value={
          (form.getValues()?.observaciones?.observacion_llamada as string) ||
          "***NO SE TIENE OBSERVACIÓN DE LLAMADA***"
        }
        disabled
      />
      {form.getValues()?.url_foto_identificacion_delantera && (
        <Grid {...gridSizeMdLg12} container item justifyContent={"center"}>
          <TabTextLabel text="Foto Identificación Delantera" />
          <ImagesWithZoom
            src={form.getValues()?.url_foto_identificacion_delantera}
            alt="Foto Identificación Delantera"
          />
        </Grid>
      )}
    </>
  );
};

export default OTDetalleClienteInstallTecnicoFormTab;
